import Image from 'next/image';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
const description = 'نوع اشتراک رو متناسب با مقطع تحصیلی و هدفی که دارید، انتخاب کنید. درصورت انتخاب و خرید اشتراک اشتباه، امکان بازگشت وجه وجود نداره.\n' + ' با خرید اشتراک، به محتوای آموزشی اشتراکی که انتخاب کردین، در طول بازه‌ی زمانی مشخص شده، دسترسی خواهید داشت.\n' + 'دسترسی به مشاهده‌ی ویدیوها و سایر محتواهای آموزشی بلافاصله بعد از خرید اشتراک، برای شما فعال می‌شه اما هیچ‌کدوم از محتواهای آموزشی سامانه آموزش مجازی آی‌نو قابلیت دانلود نداره.\n' + 'استفاده‌ی هم‌زمان چند نفر از یک اشتراک، به لحاظ شرعی و قانونی مجاز نیست و شما در هر زمان فقط می‌تونید با استفاده از یک دستگاه از اشتراک خریداری شده، استفاده کنید.';
interface ISubscriptionBuyDescriptionProps {
  acceptRole: () => void;
}
const SubscriptionBuyRules: FC<ISubscriptionBuyDescriptionProps> = ({
  acceptRole
}) => {
  const items = description.split('\n');
  return <div data-sentry-component="SubscriptionBuyRules" data-sentry-source-file="SubscriptionBuyRules.tsx">
      <div className="mb-4 flex flex-row items-center text-center text-2xl font-extrabold text-orangeFive sm:text-right  ">
        <Image className="ml-2" width={24} height={24} alt="danger" src={`${FILE_BROWSER_URL}/img/Danger_Circle.webp`} data-sentry-element="Image" data-sentry-source-file="SubscriptionBuyRules.tsx" />
        <span className=" text-base sm:text-lg">قبل از خرید حتما توجه کنید</span>
      </div>
      <ul className="grid grid-cols-1 gap-4 text-sm text-blackSix sm:text-sm ">
        {items.map(item => <li className="b mb-4 flex items-baseline" key={item}>
            <span className="ml-2 flex h-[4px] min-w-[4px] rounded-full bg-blueFive" />
            <span>{item}</span>
          </li>)}
      </ul>
      <Button onClick={() => acceptRole()} radius="medium" className=" mb-2 mt-4 w-full min-w-[280px] justify-self-end font-extrabold" color="primary" variant="contained" data-sentry-element="Button" data-sentry-source-file="SubscriptionBuyRules.tsx">
        مطالعه کردم{' '}
      </Button>
    </div>;
};
export default SubscriptionBuyRules;